/**
 * Promise的sleep
 */
export const sleep = (time = 16.7): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, time));
